import api from './axiosInstance';          // axios 인스턴스 (기본 설정된 HTTP 클라이언트)
import { fetchCsrfToken } from './csrf';    // CSRF 토큰을 받아오는 함수
import { setAccessToken } from './axiosInstance'; // 메모리상의 accessToken을 설정/제거하는 함수

/**
 * 로그아웃 처리 함수
 * - CSRF 토큰을 먼저 요청해 보안 강화
 * - 로그아웃 API 호출
 * - 메모리에 저장된 accessToken 제거
 * - 로그아웃 성공 메시지 반환
 */
export const logoutUser = async () => {
  console.log('[Logout] 로그아웃 요청 시작');

  try {
    // 1. CSRF 토큰 요청 및 처리
    await fetchCsrfToken();
    console.log('[Logout] CSRF 토큰 요청 완료');

    // 2. 로그아웃 API 호출 (withCredentials: true -> 쿠키 전송)
    const response = await api.post('/api/logout', {}, { withCredentials: true });
    console.log('[Logout] 로그아웃 응답:', response);

    // 3. accessToken 메모리에서 제거 (로그아웃 후 토큰 무효화)
    setAccessToken(null);
    console.log('[Logout] accessToken 메모리에서 제거 완료');

    // 4. 응답에서 로그아웃 성공 메시지 추출, 기본 메시지 지정
    const message = response.data?.message || '로그아웃 성공';
    console.log('[Logout] 로그아웃 메시지:', message);

    // 5. 메시지 반환
    return { message };

  } catch (error) {
    // 오류 발생 시 콘솔에 에러 로그 출력
    console.error('[Logout] 로그아웃 실패:', error);

    // 에러를 호출한 곳으로 다시 던져서 처리할 수 있도록 함
    throw error;
  }
};
